export default __webpack_public_path__ + "static/pragicts-cloudops-iot-2d4f8b34541f9ef523e49f01c676b519.jpg";